/**
 * Phone API Async Thunks
 * All async actions for phone/SMS operations
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as phoneApi from '../api/phoneApi';

/**
 * Send SMS message
 */
export const sendSMSThunk = createAsyncThunk(
  'phone/sendSMS',
  async (data, { rejectWithValue }) => {
    try {
      const result = await phoneApi.sendSMS(data);
      return result;
    } catch (error) {
      console.error('Error sending SMS:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
